import React, { useEffect } from 'react'
import {
  ReferenceInput,
  AutocompleteInput,
  useLocaleState,
  AutocompleteInputProps,
  required,
} from 'react-admin'

import { useFormContext, useWatch } from 'react-hook-form'
import { PROMOTIONS_FIELDS } from '../../../providers/localization/constant'

const defaultProps = {
  label: `${PROMOTIONS_FIELDS}.name`,
  source: 'promotion_id',
}

export const PromotionSelectInput: React.FC<AutocompleteInputProps> = ({
  label,
  source,
  ...props
}) => {
  const depField = 'action_type'
  const expectedValue = 'promotions'

  const [locale] = useLocaleState()
  const fieldCond = useWatch({ name: depField })
  const { unregister } = useFormContext()
  const validator = {
    validate: [required()],
  }

  useEffect(() => {
    if (fieldCond !== expectedValue) {
      unregister(source)
    }
  }, [fieldCond, source, unregister])
  if (!depField) return null

  const optionRenderer = (choice): string => {
    return choice[`title_${locale}`] !== undefined
      ? `${choice[`title_${locale}`] || choice['title_th']}`
      : `${PROMOTIONS_FIELDS}.clear`
  }

  return fieldCond === expectedValue ? (
    <ReferenceInput
      source={source}
      reference='promotions'
      sort={{
        field: 'create_at',
        order: 'DESC',
      }}
      filter={{
        is_published: true,
      }}
      fullWidth
    >
      <AutocompleteInput
        margin='none'
        label={label}
        size='small'
        optionValue='id'
        optionText={optionRenderer}
        {...(fieldCond === expectedValue ? validator : '')}
        {...props}
      />
    </ReferenceInput>
  ) : null
}

PromotionSelectInput.defaultProps = defaultProps
